import { useState } from 'react';
import { motion } from 'framer-motion';
import { Mail, Send } from 'lucide-react';
import { sendNewsletter } from '../services/emailjs';
import toast from 'react-hot-toast';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !email.includes('@')) {
      toast.error('Please enter a valid email address');
      return;
    }

    setLoading(true);
    const result = await sendNewsletter(email);
    setLoading(false);

    if (result.success) {
      toast.success('Successfully subscribed to newsletter!');
      setEmail('');
    } else {
      toast.error('Failed to subscribe. Please try again.');
    }
  };

  return (
    <div className="bg-black text-white py-16 px-4 rounded-2xl">
      <div className="max-w-3xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <div className="flex justify-center mb-4">
            <Mail size={48} />
          </div>
          <h2 className="heading-3 mb-4">Subscribe to Our Newsletter</h2>
          <p className="text-gray-400 mb-8 font-body">
            Get the latest articles and insights delivered directly to your inbox.
            No spam, unsubscribe anytime.
          </p>

          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="flex-1 px-6 py-4 rounded-lg bg-white text-black font-body focus:outline-none focus:ring-2 focus:ring-white"
              disabled={loading}
            />
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              type="submit"
              disabled={loading}
              className="px-8 py-4 bg-white text-black rounded-lg font-body font-semibold hover:bg-gray-200 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
            >
              {loading ? (
                'Subscribing...'
              ) : (
                <>
                  Subscribe
                  <Send size={18} className="ml-2" />
                </>
              )}
            </motion.button>
          </form>
        </motion.div>
      </div>
    </div>
  );
};

export default Newsletter;
